import { IAddressEntity } from "../addresses/addresses.interface"
import { ICustomerEntity } from "../customers/customers.interface"
import { IProductEntity } from "../products/products.interface"
import { ISellerEntity } from "../sellers/sellers.interface"
import { IServiceOrderEntity, IServiceOrderProduct, TStoreType } from "../service-orders/service-order.interface"



export enum OrderStatusEnum {
    OPEN = "OPEN",
    PROCESSING = "PROCESSING",
    DEAD = "DEAD",
  
    CANCELING = "CANCELING",
    CANCELED = "CANCELED",
    COMPLETED = "COMPLETED",
  
    AWAITING_PICKING = "AWAITING_PICKING", // Os pedidos que chegarem da Nuvem sem a necessidade do fluxo de produção (todos B2B hoje), devem entrar automaticamente para esse status
    IN_PICKING = "IN_PICKING",
  
    AWAITING_INVOICING = "AWAITING_INVOICING", // Novo status para WAITING_BILLING
  
    INVOICING = "INVOICING", // Esse status será aplicado quando for executado a criação do pedido no Omie e está aguardando o omie completar o fluxo de faturar o pedido - Status antes do "INVOICED"
  
    INVOICE_PROBLEM = "INVOICE_PROBLEM",
  
    PARTIALLY_INVOICED = "PARTIALLY_INVOICED", // Alterar o nome HALF_BILLED para "PARTIALLY_INVOICED". Status utilizado quando parte do pedido foi faturado com sucesso e a outra parte deu erro
  
    INVOICED = "INVOICED", //
  
  }

export type TOrderProductionStatus = "STAND_BY" | "PRODUCTION" | "HALF_FINISHED" | "FINISHED" | "BILLED"

export enum OrderProductionStatusEnum {
    STAND_BY = "STAND_BY",
    PRODUCTION = "PRODUCTION",
    HALF_FINISHED = "HALF_FINISHED",
    FINISHED = "FINISHED",
    // BILLED = "BILLED"
}

export type TOrdersOmieType = "SERVICE" | "SALES" | "RESALE"
export interface IOrdersRegisteredOnOmieEntity {
    id: string
    createdAt: string
    updatedAt: string
    type: TOrdersOmieType
    hubOrderId:string
    hubServiceOrdersIds: string[]
    nsOrderId: string
    omieOrderId: string
    serviceOrders: IServiceOrderEntity[]
    omieOriginalOrderId?: string
    products?: IProductEntity[]
}


export interface IOrderEntity {
    id: string
    createdAt: string
    status: OrderStatusEnum
    erp: "NUVEMSHOP"
    errorMessage?: string,
    store: TStoreType
    totalValue: string
    originalValue: string
    discountValue: string
    productionStatus: TOrderProductionStatus
    orderId: string
    orderStringified: string
    nsOrderId?: string;
    dueDate: string
    nsSellerEmail?: string
    omieShippingCarrierId?:string
    omieCategoryId: string
    omieSellerId?: string
    omieCustomerId: string
    omieAccountReceivableId: string
    products: IServiceOrderProduct[]
    ordersRegisteredOnOmie?: IOrdersRegisteredOnOmieEntity[]
    customer?: ICustomerEntity;
    sellerAlreadyAdded?: boolean
    seller?: ISellerEntity
    shippingAddress?: IAddressEntity
    billingAddress?: IAddressEntity
    observations?: string
   
}

export interface IOrdersListPayload {
    page: number
    searchBy?: string
    status?: string[]
    store?: 'B2B' | 'B2C'
    startDate?: string
    endDate?: string
    orderBy?: {
        field: string
        order: 'ASC' | 'DESC'
    }
}

export interface IOrdersListResponse{
    hasNextPage: boolean;
    data: IOrderEntity[];
    total: number;
    
}

export interface IBillProductOrderPayload {
    orderId: string;
    productsIds: string[]
}

export interface IUploadOrderPayload {
    orderId: string;
    sellerId?: string
    newStatus?: OrderStatusEnum
    observations?: string
}

export interface IPickingFlowResponse {
    orderId: string
    nsOrderId: string
    orderStatus: OrderStatusEnum
    customerId: string
    customerName: string
    carrierId: string
    carrierName: string
    orderObservations?: string
}

export interface ICancelOrderPayload {
    orderId: string;
    reason?: string;
}

export interface IImportOrderPayload {
    orderId: string;
    store: TStoreType;
}